import { ReactNode } from 'react'
import { toast, ToastOptions } from 'react-toastify'

import { ToastText } from '@app/components/ToastText/ToastText'

export const showToast = (text: ReactNode, options?: ToastOptions) => {
  toast(<ToastText text={text} traceId={options?.data?.['traceId']} />, {
    theme: 'dark',
    type: 'success',
    ...options
  })
}
